import { EditOutlined } from "@ant-design/icons";
import FormatCard from "@entities/deliverableConfigurator/ui/FormatCard";
import FormatForm from "@features/deliverableConfigurator/ui/FormatForm";
import {
  IDeliverableConfigurator,
  IDeliverableFormat,
} from "@shared/lib/types";
import { Button } from "@shared/ui/Button";
import {
  Card,
  Descriptions,
  Flex,
  List,
  Modal,
  Space,
  Tag,
  Typography,
} from "antd";
import { useState } from "react";

export default function FormatCards({
  formats,
  deliverableId,
}: {
  formats: IDeliverableFormat[];
  deliverableId: string;
}) {
  const [openModal, setOpenModal] = useState<boolean>(false);
  return (
    <div style={{ padding: 0 }}>
      <Flex justify="space-between" align="center">
        <Typography.Title level={5}>Formats</Typography.Title>
        <Button onClick={() => setOpenModal(true)}>Add Format</Button>
      </Flex>
      <List
        dataSource={formats}
        renderItem={(fmt) => (
          <List.Item key={fmt._id}>
            <FormatCard format={fmt} deliverableId={deliverableId} />
          </List.Item>
        )}
        pagination={{
          pageSize: 10,
          hideOnSinglePage: true,
        }}
      />
      <Modal
        open={openModal}
        title={"Add Format"}
        footer={null}
        destroyOnClose
        onCancel={() => setOpenModal(false)}
      >
        <FormatForm
          format={null}
          onClose={() => setOpenModal(false)}
          isEdit={false}
          deliverableId={deliverableId}
        />
      </Modal>
    </div>
  );
}
